var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11C2.46235 11 0 8.53765 0 5.5C0 2.46235 2.46235 0 5.5 0C8.53765 0 11 2.46235 11 5.5C11 8.53765 8.53765 11 5.5 11ZM5.5 9.9C6.66695 9.9 7.78611 9.43643 8.61127 8.61127C9.43643 7.78611 9.9 6.66695 9.9 5.5C9.9 4.33305 9.43643 3.21389 8.61127 2.38873C7.78611 1.56357 6.66695 1.1 5.5 1.1C4.33305 1.1 3.21389 1.56357 2.38873 2.38873C1.56357 3.21389 1.1 4.33305 1.1 5.5C1.1 6.66695 1.56357 7.78611 2.38873 8.61127C3.21389 9.43643 4.33305 9.9 5.5 9.9ZM4.95 2.75H6.05V3.85H4.95V2.75ZM4.95 4.95H6.05V8.25H4.95V4.95Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsIcon);
export default __webpack_public_path__ + "static/media/DetailsIcon.72cd00979b4b56338c48440c3a8b55c8.svg";
export { ForwardRef as ReactComponent };